import React, { useMemo, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

export default function NowWeekend() {
  const { data, loading, error } = useFetchWithAuth("/statistic/workdays/");
  const [openAll, setOpenAll] = useState(false);
  const limit = 6;

  const payload = data?.data ?? data ?? {};
  const operatorsDayOff = Array.isArray(payload?.dayoff)
    ? payload.dayoff
    : Array.isArray(payload?.day_off)
    ? payload.day_off
    : Array.isArray(payload?.weekend)
    ? payload.weekend
    : [];

  const previewRows = useMemo(
    () => operatorsDayOff.slice(0, limit),
    [operatorsDayOff, limit]
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <Box className="rmui-card" sx={{ p: 3, mb: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" className="text-black" fontWeight="bold">
          Сьогодні вихідні
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            color: "#6A4FFF",
          }}
          onClick={() => setOpenAll(true)}
        >
          Див. всіх
        </Typography>
      </Box>

      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none" }}
        className="rmui-table border-bottom"
      >
        <Table>
          <TableHead className="bg-f6f7f9">
            <TableRow>
              <TableCell
                className="text-black border-bottom"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              >
                Ім’я
              </TableCell>
              <TableCell
                className="text-black border-bottom"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              >
                &nbsp;
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {previewRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  Немає даних
                </TableCell>
              </TableRow>
            ) : (
              previewRows.map((op, index) => {
                const fullName = `${op.first_name || ""} ${
                  op.last_name || ""
                }`.trim();

                return (
                  <TableRow key={op.id || index}>
                    <TableCell className="border-bottom">
                      {fullName || op.username}
                    </TableCell>
                    <TableCell className="border-bottom" align="right">
                      {op.telegram && (
                        <IconButton
                          sx={{ color: "#6A4FFF" }}
                          onClick={() =>
                            window.open(`https://t.me/${op.telegram}`, "_blank")
                          }
                        >
                          <img
                            src="/img/supervisor/hugeicons_telegram.svg"
                            alt="telegram"
                            width="20"
                            height="20"
                          />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openAll} onClose={() => setOpenAll(false)} fullWidth>
        <DialogTitle>Сьогодні вихідні</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table size="small">
              <TableHead className="bg-f6f7f9">
                <TableRow>
                  <TableCell
                    className="text-black border-bottom"
                    sx={{ fontWeight: "500", fontSize: "14px" }}
                  >
                    Ім’я
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {operatorsDayOff.length === 0 ? (
                  <TableRow>
                    <TableCell align="center">Немає даних</TableCell>
                  </TableRow>
                ) : (
                  operatorsDayOff.map((op, index) => {
                    const fullName = `${op.first_name || ""} ${
                      op.last_name || ""
                    }`.trim();
                    return (
                      <TableRow key={op.id || index}>
                        <TableCell className="border-bottom">
                          {fullName || op.username}
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAll(false)}>Закрити</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
